/* ============================================================
   BESA BESË™ — THEME JS
   Vanilla JS · No jQuery · No framework
   ============================================================ */

(function () {
  'use strict';

  var STR = (window.theme && window.theme.strings) || {};
  var T_ADDED = STR.addedToBag || 'ADDED TO CART.';
  var T_ADDING = STR.adding || 'ADDING...';
  var T_ADD_TO_BAG = STR.addToBag || 'ADD TO CART';
  var T_QTY_ERROR = STR.quantityErrorFallback || 'Could not update quantity.';

  /* ---------- Announcement Bar Rotator ---------- */
  function initAnnouncementBar() {
    const bar = document.querySelector('.announcement-bar');
    if (!bar) return;

    const messages = Array.from(bar.querySelectorAll('.announcement-bar__message'));
    if (!messages.length) return;

    const speed = parseInt(bar.dataset.speed, 10) || 4000;
    let current = 0;
    messages[0].classList.add('is-active');

    if (messages.length > 1) {
      setInterval(() => {
        messages[current].classList.remove('is-active');
        current = (current + 1) % messages.length;
        messages[current].classList.add('is-active');
      }, speed);
    }

    const dismiss = bar.querySelector('.announcement-bar__dismiss');
    if (dismiss) {
      dismiss.addEventListener('click', () => {
        const h = bar.offsetHeight;
        bar.style.height = h + 'px';
        bar.style.overflow = 'hidden';
        requestAnimationFrame(() => {
          bar.style.transition = 'height 300ms ease, opacity 300ms ease';
          bar.style.height = '0';
          bar.style.opacity = '0';
        });
        document.documentElement.style.setProperty('--bar-height', '0px');
      });
    }
  }

  /* ---------- Cart Badge ---------- */
  async function updateCartBadge() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      document.querySelectorAll('.cart-badge').forEach(badge => {
        badge.textContent = cart.item_count;
        badge.classList.toggle('has-items', cart.item_count > 0);
        badge.setAttribute('aria-label', cart.item_count + ' items in cart');
      });
    } catch (_) {}
  }

  /* ---------- Cart Notification Toast ---------- */
  let notifTimer;
  function showCartNotification(msg) {
    const el = document.getElementById('cart-notification');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(notifTimer);
    notifTimer = setTimeout(() => el.classList.remove('is-visible'), 2600);
  }

  /* ---------- Format Money ---------- */
  function formatMoney(cents) {
    const locale = document.documentElement.lang || 'de-DE';
    return new Intl.NumberFormat(locale, { style: 'currency', currency: 'EUR' }).format(cents / 100);
  }

  /* ---------- HTML escape (for dynamic, API-sourced text only — translated
     strings from window.theme.strings are already safe as-is) ---------- */
  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, c => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    })[c]);
  }

  /* ---------- Cart Drawer ---------- */
  function cartDrawerEls() {
    return {
      drawer: document.getElementById('cart-drawer'),
      itemsEl: document.getElementById('cart-drawer-items'),
      footerEl: document.getElementById('cart-drawer-footer')
    };
  }

  function openCartDrawer() {
    const { drawer } = cartDrawerEls();
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    lockBodyScroll();
  }

  function closeCartDrawer() {
    const { drawer } = cartDrawerEls();
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    unlockBodyScroll();
  }

  function renderCartDrawer(cart) {
    const { itemsEl, footerEl } = cartDrawerEls();
    if (!itemsEl || !footerEl) return;

    if (!cart.items.length) {
      itemsEl.innerHTML = '<p class="cart-drawer__empty">' + STR.cartEmpty + '</p>';
      footerEl.innerHTML = '';
      return;
    }

    itemsEl.innerHTML = cart.items.map((item, i) => {
      const line = i + 1;
      const metaParts = [];
      if (item.variant_title && item.variant_title !== 'Default Title') metaParts.push(item.variant_title);
      if (item.quantity > 1) metaParts.push((STR.cartQtyLabel || 'QTY') + ' ' + item.quantity);
      const metaLine = metaParts.length
        ? '<p class="cart-drawer-item__meta">' + escapeHtml(metaParts.join(' · ')) + '</p>'
        : '';
      const imgSrc = item.image ? item.image.replace(/(\.[a-zA-Z0-9]+)(\?.*)?$/, '_300x$1') : '';
      const removeLabel = (STR.cartRemoveItem || 'Remove {{ title }}').replace('{{ title }}', item.product_title);
      return (
        '<div class="cart-drawer-item" data-line="' + line + '">' +
          '<div class="cart-drawer-item__img">' +
            (imgSrc ? '<img src="' + imgSrc + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">' : '') +
          '</div>' +
          '<div class="cart-drawer-item__info">' +
            '<p class="cart-drawer-item__title">' + escapeHtml(item.product_title) + '</p>' +
            metaLine +
            '<p class="cart-drawer-item__price">' + formatMoney(item.final_line_price) + '</p>' +
          '</div>' +
          '<button type="button" class="cart-drawer-item__remove" data-line="' + line + '" aria-label="' + escapeHtml(removeLabel) + '">&times;</button>' +
        '</div>'
      );
    }).join('');

    footerEl.innerHTML =
      '<div class="cart-drawer__subtotal-row"><span>' + STR.cartSubtotal + '</span><span>' + formatMoney(cart.total_price) + '</span></div>' +
      '<a href="/checkout" class="btn btn-primary cart-drawer__checkout">' + STR.cartCheckout + '</a>' +
      '<p class="cart-drawer__note">' + STR.cartShippingNote + '</p>';
  }

  async function refreshCartDrawer() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      renderCartDrawer(cart);
      return cart;
    } catch (_) {}
  }

  function initCartDrawer() {
    const { drawer } = cartDrawerEls();
    if (!drawer) return;
    const overlay = drawer.querySelector('.cart-drawer__overlay');
    const closeBtn = drawer.querySelector('.cart-drawer__close');

    overlay.addEventListener('click', closeCartDrawer);
    closeBtn.addEventListener('click', closeCartDrawer);
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeCartDrawer();
    });

    drawer.addEventListener('click', async e => {
      const removeBtn = e.target.closest('.cart-drawer-item__remove');
      if (!removeBtn) return;
      const line = parseInt(removeBtn.dataset.line, 10);
      removeBtn.disabled = true;
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line, quantity: 0 })
        });
        const cart = await res.json();
        renderCartDrawer(cart);
        updateCartBadge();
      } catch (_) {
        removeBtn.disabled = false;
      }
    });
  }

  /* ---------- Quick Add ---------- */
  function initQuickAdd() {
    const modal = document.getElementById('quick-add-modal');
    if (!modal) return;

    const overlay  = modal.querySelector('.quick-add-modal__overlay');
    const closeBtn = modal.querySelector('.quick-add-modal__close');
    const titleEl  = modal.querySelector('.quick-add-modal__title');
    const priceEl  = modal.querySelector('.quick-add-modal__price');
    const sizesEl  = modal.querySelector('.quick-add-modal__sizes');
    const addBtn   = modal.querySelector('.quick-add-modal__add');

    let selectedVariant = null;
    let previousFocus   = null;

    function openModal(handle) {
      fetch('/products/' + handle + '.js')
        .then(r => r.json())
        .then(product => {
          titleEl.textContent = product.title;
          priceEl.textContent = formatMoney(product.price);
          sizesEl.innerHTML = '';
          selectedVariant = null;
          addBtn.disabled = true;

          product.variants.forEach(v => {
            const btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'variant-btn' + (v.available ? '' : ' is-unavailable');
            btn.textContent = v.title;
            btn.dataset.variantId = v.id;
            if (!v.available) btn.disabled = true;
            btn.addEventListener('click', () => {
              sizesEl.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('is-selected'));
              btn.classList.add('is-selected');
              selectedVariant = v.id;
              addBtn.disabled = false;
            });
            sizesEl.appendChild(btn);
          });

          if (product.variants.length === 1 && product.variants[0].available) {
            sizesEl.querySelector('.variant-btn')?.click();
          }

          previousFocus = document.activeElement;
          modal.setAttribute('aria-hidden', 'false');
          modal.classList.add('is-open');
          document.body.style.overflow = 'hidden';
          closeBtn.focus();
        })
        .catch(() => {});
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (previousFocus) previousFocus.focus();
    }

    /* Focus trap */
    modal.addEventListener('keydown', e => {
      if (e.key === 'Escape') { closeModal(); return; }
      if (e.key !== 'Tab') return;
      const focusable = Array.from(
        modal.querySelectorAll('button:not([disabled]), input, [tabindex="0"]')
      );
      if (!focusable.length) return;
      const first = focusable[0];
      const last  = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault(); first.focus();
      }
    });

    overlay.addEventListener('click', closeModal);
    closeBtn.addEventListener('click', closeModal);

    addBtn.addEventListener('click', async () => {
      if (!selectedVariant) return;
      addBtn.disabled = true;
      addBtn.textContent = T_ADDING;
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: selectedVariant, quantity: 1 })
        });
        if (!res.ok) throw new Error();
        closeModal();
        updateCartBadge();
        if (window.location.pathname.includes('cart')) {
          setTimeout(() => location.reload(), 300);
        } else {
          await refreshCartDrawer();
          openCartDrawer();
        }
      } catch (_) {
        addBtn.textContent = T_ADD_TO_BAG;
        addBtn.disabled = false;
      }
    });

    /* Delegate quick-add button clicks from product cards */
    document.addEventListener('click', e => {
      const btn = e.target.closest('[data-quick-add]');
      if (!btn) return;
      e.preventDefault();
      const handle    = btn.dataset.quickAdd;
      const variantId = btn.dataset.variantId;

      if (variantId) {
        /* Single variant — add directly without modal */
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
        })
          .then(() => {
            updateCartBadge();
            if (window.location.pathname.includes('cart')) {
              setTimeout(() => location.reload(), 300);
            } else {
              refreshCartDrawer().then(openCartDrawer);
            }
          })
          .catch(() => {});
      } else if (handle) {
        openModal(handle);
      }
    });
  }

  /* ---------- Hotspots ---------- */
  function initHotspots() {
    document.querySelectorAll('.hotspot').forEach(hotspot => {
      const btn = hotspot.querySelector('.hotspot__btn');
      const card = hotspot.querySelector('.hotspot__card');
      if (!btn) return;
      btn.addEventListener('click', e => {
        e.stopPropagation();
        const isOpen = hotspot.classList.contains('is-open');
        document.querySelectorAll('.hotspot.is-open').forEach(h => h.classList.remove('is-open', 'hotspot--flip'));
        if (!isOpen) {
          hotspot.classList.add('is-open');
          if (card) {
            const btnRect = btn.getBoundingClientRect();
            const cardHeight = card.offsetHeight;
            const spaceAbove = btnRect.top;
            const spaceBelow = window.innerHeight - btnRect.bottom;
            if (spaceAbove < cardHeight + 20 && spaceBelow > spaceAbove) {
              hotspot.classList.add('hotspot--flip');
            }
          }
        }
      });
      btn.addEventListener('keydown', e => {
        if (e.key === 'Escape') hotspot.classList.remove('is-open', 'hotspot--flip');
      });
    });

    document.addEventListener('click', () => {
      document.querySelectorAll('.hotspot.is-open').forEach(h => h.classList.remove('is-open', 'hotspot--flip'));
    });
  }

  /* ---------- Email Capture ---------- */
  function initEmailCapture() {
    const capture = document.getElementById('email-capture');
    if (!capture) return;
    if (sessionStorage.getItem('bb_email_dismissed')) return;

    const delay   = parseInt(capture.dataset.delay, 10) || 8000;
    const dismiss = capture.querySelector('.email-capture__dismiss');

    setTimeout(() => capture.classList.add('is-visible'), delay);

    function hide() {
      capture.classList.remove('is-visible');
      sessionStorage.setItem('bb_email_dismissed', '1');
    }

    if (dismiss) dismiss.addEventListener('click', hide);

    const form = capture.querySelector('form');
    if (form) {
      form.addEventListener('submit', () => setTimeout(hide, 1200));
    }
  }

  /* ---------- Product Gallery ---------- */
  function initProductGallery() {
    const gallery = document.querySelector('.main-product__gallery');
    if (!gallery) return;

    const mainImg = gallery.querySelector('.main-product__gallery-main img');
    gallery.querySelectorAll('.main-product__thumb').forEach(thumb => {
      thumb.addEventListener('click', () => {
        gallery.querySelectorAll('.main-product__thumb').forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
        if (mainImg) {
          const thumbImg = thumb.querySelector('img');
          if (thumbImg) {
            const src = thumbImg.src.replace(/width=\d+/, 'width=1500');
            mainImg.src = src;
            mainImg.srcset = '';
          }
        }
      });
    });
  }

  /* ---------- Variant Selection (product page) ---------- */
  function initVariantSelection() {
    const form = document.querySelector('.main-product__form');
    if (!form) return;

    const variantInput  = form.querySelector('[name="id"]');
    const addBtn        = form.querySelector('.main-product__add');
    const stickyBtn      = document.getElementById('sticky-atb-btn');
    const priceEl        = document.getElementById('product-price');
    const stickyPriceEl  = document.getElementById('sticky-atb-price');

    /* Full variant matrix (id, option1/2/3, availability, price, image), so
       switching one option (e.g. size) always resolves the variant using
       ALL currently-selected options together, not just the one clicked. */
    const variantsScript = document.getElementById('product-variants-json');
    let variants = [];
    if (variantsScript) {
      try { variants = JSON.parse(variantsScript.textContent) || []; } catch (_) {}
    }

    const currentVariant = variants.find(v => String(v.id) === String(variantInput && variantInput.value)) || variants[0];
    const selectedOptions = currentVariant
      ? [currentVariant.option1, currentVariant.option2, currentVariant.option3]
      : [];

    function findVariant(options) {
      return variants.find(v =>
        (options[0] == null || v.option1 === options[0]) &&
        (options[1] == null || v.option2 === options[1]) &&
        (options[2] == null || v.option3 === options[2])
      );
    }

    function applyVariant(variant) {
      if (!variant) return;
      if (variantInput) variantInput.value = variant.id;

      const unavailable = !variant.available;
      if (addBtn) {
        addBtn.disabled = unavailable;
        addBtn.textContent = variant.available ? T_ADD_TO_BAG : (STR.soldOut || 'SOLD OUT');
      }
      if (stickyBtn) {
        stickyBtn.disabled = unavailable;
        stickyBtn.textContent = variant.available ? T_ADD_TO_BAG : (STR.soldOut || 'SOLD OUT');
      }

      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (stickyPriceEl) stickyPriceEl.textContent = formatMoney(variant.price);

      const variantImage = variant.featured_image && variant.featured_image.src;
      if (variantImage) {
        const galleryMain = document.querySelector('.main-product__gallery-main');
        const mainImg = galleryMain ? galleryMain.querySelector('img') : null;
        if (mainImg && mainImg.src.split('?')[0] !== variantImage.split('?')[0]) {
          mainImg.src = variantImage;
          mainImg.srcset = '';
        }
      }
    }

    form.querySelectorAll('.variant-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const group = btn.closest('.main-product__variants');
        if (!group) return;
        const optionIndex = parseInt(group.dataset.optionIndex, 10) - 1;
        const value = btn.dataset.value;
        if (Number.isNaN(optionIndex) || value == null) return;

        group.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('is-selected'));
        btn.classList.add('is-selected');

        selectedOptions[optionIndex] = value;

        const matched = findVariant(selectedOptions);
        applyVariant(matched);
      });
    });

    /* Ajax add-to-cart on product page (also used by the sticky bar button) */
    async function addCurrentVariantToCart(triggerBtn) {
      const id = variantInput?.value;
      if (!id) return;
      const originalText = triggerBtn ? triggerBtn.textContent : '';
      if (triggerBtn) { triggerBtn.disabled = true; triggerBtn.textContent = T_ADDING; }
      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(id, 10), quantity: 1 })
        });
        updateCartBadge();
        await refreshCartDrawer();
        openCartDrawer();
      } catch (_) {}
      if (triggerBtn) { triggerBtn.disabled = false; triggerBtn.textContent = originalText || T_ADD_TO_BAG; }
    }

    form.addEventListener('submit', e => {
      e.preventDefault();
      addCurrentVariantToCart(addBtn);
    });

    if (stickyBtn) {
      stickyBtn.addEventListener('click', () => addCurrentVariantToCart(stickyBtn));
    }
  }

  /* ---------- Sticky Add-to-Bag Bar (mobile, product page) ---------- */
  /* Shows once the real "Add to Cart" button scrolls out of view. Also
     watches the footer: without this, the bar stayed fixed over the
     bottom of the screen for the rest of the page, permanently covering
     the last ~70px of the footer (copyright line, payment icons) once
     scrolled that far — it read as "the footer stops/gets cut off" since
     the bar's dark background nearly matches the footer's own. Only
     became reachable/visible to customers once the Instagram in-app-
     browser text-cutoff fix let them actually scroll all the way down. */
  function initStickyAtb() {
    const bar = document.getElementById('sticky-atb');
    const mainBtn = document.querySelector('.main-product__add');
    const footer = document.querySelector('footer');
    if (!bar || !mainBtn || typeof IntersectionObserver === 'undefined') return;

    let btnVisible = true;
    let footerVisible = false;

    function sync() {
      bar.classList.toggle('sticky-atb--visible', !btnVisible && !footerVisible);
    }

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.target === mainBtn) btnVisible = entry.isIntersecting;
        if (entry.target === footer) footerVisible = entry.isIntersecting;
      });
      sync();
    }, { rootMargin: '0px 0px -10% 0px' });

    observer.observe(mainBtn);
    if (footer) observer.observe(footer);
  }

  /* ---------- Cart Quantity ---------- */
  function initCartQuantity() {
    document.addEventListener('click', async e => {
      const btn = e.target.closest('.qty-btn');
      if (!btn) return;
      const item = btn.closest('[data-line]');
      if (!item) return;

      const line  = parseInt(item.dataset.line, 10);
      const qtyEl = item.querySelector('.cart-item__qty-value');
      let qty     = parseInt(qtyEl?.textContent || '1', 10);

      if (btn.dataset.action === 'minus') qty = Math.max(0, qty - 1);
      if (btn.dataset.action === 'plus')  qty++;

      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line, quantity: qty })
        });
        const data = await res.json();
        if (!res.ok) {
          showCartNotification(data.message || T_QTY_ERROR);
          return;
        }
        updateCartBadge();
        location.reload();
      } catch (_) {
        showCartNotification(T_QTY_ERROR);
      }
    });
  }

  /* ---------- Header Scroll Shadow ---------- */
  function initHeaderScroll() {
    const header = document.querySelector('.site-header');
    if (!header) return;
    let lastY = 0;
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 10);
      lastY = y;
    }, { passive: true });
  }

  /* ---------- Mobile Nav ---------- */
  let mobileNavScrollY = 0;

  function lockBodyScroll() {
    mobileNavScrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = -mobileNavScrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }

  function unlockBodyScroll() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, mobileNavScrollY);
  }

  function initMobileNav() {
    const toggle = document.querySelector('.site-header__mobile-toggle');
    const nav    = document.querySelector('.site-header__mobile-nav');
    if (!toggle || !nav) return;

    toggle.addEventListener('click', () => {
      const isOpen = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(isOpen));
      if (isOpen) {
        lockBodyScroll();
      } else {
        unlockBodyScroll();
      }
    });
  }

  async function syncFreeGift() {}

  async function removeFreeGifts() {
    try {
      const res  = await fetch('/cart.js');
      const cart = await res.json();
      const gifts = cart.items.filter(i => i.properties && i.properties._free_gift);
      if (!gifts.length) return;
      for (let i = 0; i < gifts.length; i++) {
        const line = cart.items.indexOf(gifts[i]) + 1;
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line, quantity: 0 })
        });
      }
      location.reload();
    } catch (_) {}
  }

  /* ---------- Init ---------- */
  document.addEventListener('DOMContentLoaded', () => {
    initAnnouncementBar();
    updateCartBadge();
    initQuickAdd();
    initCartDrawer();
    initHotspots();
    initEmailCapture();
    initProductGallery();
    initVariantSelection();
    initStickyAtb();
    initCartQuantity();
    initHeaderScroll();
    initMobileNav();
    if (document.querySelector('.main-cart')) removeFreeGifts();
  });
})();
